// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Slider_Slider__p3xcz","Slider_wrapper":"Slider_Slider_wrapper__YcbiT","Slider_slide":"Slider_Slider_slide__ENbPW","Slider_heading":"Slider_Slider_heading__Oe8vh"};